// extracted by mini-css-extract-plugin
export var actions = "_ur-4";
export var item = "_ur-1";
export var price = "_ur-3";
export var quantity = "_ur-2";
export var table = "_ur-0";